import type { DossierFile, Folder } from '../services/files/filesService';

export type DocumentTreeNode = {
  folder: Folder;
  children: DocumentTreeNode[];
  files: DossierFile[];
  fileCount: number;
};

export type DocumentTree = {
  rootFolders: DocumentTreeNode[];
  rootFiles: DossierFile[];
};

function byFolderName(a: Folder, b: Folder): number {
  return a.name.localeCompare(b.name, 'fr');
}

function byCreatedAtDesc(a: DossierFile, b: DossierFile): number {
  return b.created_at.localeCompare(a.created_at);
}

export function buildDocumentTree(folders: Folder[], files: DossierFile[]): DocumentTree {
  const byId = new Map<string, DocumentTreeNode>();
  for (const folder of folders) {
    byId.set(folder.id, { folder, children: [], files: [], fileCount: 0 });
  }

  const rootFolders: DocumentTreeNode[] = [];
  const sortedFolders = [...folders].sort(byFolderName);
  for (const folder of sortedFolders) {
    const node = byId.get(folder.id)!;
    if (folder.parent_id && byId.has(folder.parent_id)) {
      byId.get(folder.parent_id)!.children.push(node);
    } else {
      rootFolders.push(node);
    }
  }

  const rootFiles: DossierFile[] = [];
  for (const file of files) {
    if (file.folder_id && byId.has(file.folder_id)) {
      byId.get(file.folder_id)!.files.push(file);
    } else {
      rootFiles.push(file);
    }
  }

  for (const node of byId.values()) {
    node.files.sort(byCreatedAtDesc);
    node.fileCount = node.files.length;
  }
  rootFiles.sort(byCreatedAtDesc);
  rootFolders.sort((a, b) => byFolderName(a.folder, b.folder));

  return { rootFolders, rootFiles };
}
